export function stringDateToNumber(d) {
  // throw error if they passing different param type than string

  const numDate = new Date(d).getTime();

  return numDate;
}
